(function () {
  "use strict";

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* The gallery and the quantity stepper belong to every product, including
     the ones that have a single build and therefore render no variant select.
     Both used to sit below a guard that returned early when that select was
     absent, so on those products the picture could not be changed and the
     quantity could not be raised — six photographs on the page and no way to
     reach five of them. Each concern is wired on its own now, and only the
     variant logic returns when there is no select to read. */

  function initGallery(root) {
    $$("[data-thumb]", root).forEach(function (t) {
      t.addEventListener("click", function () {
        var main = $("[data-main-media]", root);
        if (main && t.dataset.thumb) {
          main.src = t.dataset.thumb;
          main.srcset = t.dataset.thumbSrcset || "";
        }
        $$("[data-thumb]", root).forEach(function (x) {
          x.setAttribute("aria-pressed", String(x === t));
        });
      });
    });
  }

  function initQty(root) {
    var q = $("[data-qty]", root);
    if (!q) return;
    $$("[data-qty-step]", root).forEach(function (b) {
      b.addEventListener("click", function (e) {
        e.preventDefault();
        var v = parseInt(q.value, 10) || 1;
        q.value = Math.max(1, v + parseInt(b.dataset.qtyStep, 10));
      });
    });
  }

  function initVariants(root) {
    var sel = $("[data-variant-select]", root);
    var form = $(".mps-buyform", root);
    if (!sel || !form) return;

    var idIn = $("[data-variant-id]", form);
    var price = $("[data-price]", root);
    var btn = $("[data-add]", root);

    function pick() {
      var o = sel.options[sel.selectedIndex];
      if (!o) return;
      if (idIn) idIn.value = o.value;
      if (price && o.dataset.price) price.textContent = o.dataset.price;
      if (btn) {
        var avail = o.dataset.available !== "false";
        btn.disabled = !avail;
        btn.textContent = avail ? btn.dataset.labelOn : btn.dataset.labelOff;
      }
      $$("[data-size-panel]", root).forEach(function (p) {
        p.hidden = p.dataset.sizePanel !== o.value;
      });
      var lab = $("[data-size-label]", root);
      if (lab) lab.textContent = o.dataset.label || o.textContent;
    }

    sel.addEventListener("change", pick);
    pick();
  }

  function initProduct(root) {
    if (root.dataset.mpShop) return;
    root.dataset.mpShop = "1";
    initGallery(root);
    initQty(root);
    initVariants(root);
  }

  function initLibrary(root) {
    var input = $("[data-lib-filter]", root);
    var rows = $$("[data-lib-row]", root);
    var count = $("[data-lib-count]", root);
    if (!input || !rows.length) return;
    var t;
    input.addEventListener("input", function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var q = input.value.trim().toLowerCase();
        var n = 0;
        rows.forEach(function (r) {
          var hit = !q || (r.dataset.hay || "").indexOf(q) > -1;
          r.hidden = !hit;
          if (hit) n++;
        });
        if (count) count.textContent = n;
      }, 180);
    });
  }

  function initSort() {
    var sort = $("[data-sort]");
    if (!sort) return;
    sort.addEventListener("change", function () {
      if (sort.value) window.location.href = sort.value;
    });
  }

  function boot() {
    $$("[data-product-root]").forEach(initProduct);
    $$("[data-library]").forEach(initLibrary);
    initSort();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
}());
